import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastRootFn = /* @__PURE__ */ createRecipe('toast-root', {}, [])

const toastRootVariantMap = {}

const toastRootVariantKeys = Object.keys(toastRootVariantMap)

export const toastRoot = /* @__PURE__ */ Object.assign(memo(toastRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastRoot',
  __getCompoundVariantCss__: toastRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastRootVariantKeys,
  variantMap: toastRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastRootVariantKeys)
  },
  getVariantProps: toastRootFn.getVariantProps,
})